/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import clsx from 'clsx';
import { axiosUser } from '@axios/axiosInstances';
import { Dropdown } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { useLang, setLanguage } from '../../../../i18n';
import { DropdownTopbarItemToggler } from '../../../../_partials/dropdowns';
import { BACKEND_URL } from '../../../../../config';
import * as auth from '../../../../../app/modules/Auth/_redux/authRedux';
import { languages } from './constants/languages';

export function LanguageSelectorDropdown() {
  const lang = useLang();
  const dispatch = useDispatch();

  const user = useSelector(state => state.auth.user);

  const currentLanguage = languages.find(x => x.lang === lang) || languages[0];

  async function changeLanguage(newLanguage) {
    if (user) {
      await saveUserLanguage(newLanguage);
    }
    setLanguage(newLanguage);
  }

  async function saveUserLanguage(newLang) {
    try {
      const res = await axiosUser.put(`${BACKEND_URL}/shopUser/setting/`, {
        lang: newLang,
        shopUser: user.shopUserId
      });

      const newLanguage = res.data.data.lang;
      dispatch({
        type: auth.actionTypes.UserSettingUpdated,
        payload: {
          setting: {
            lang: newLanguage
          }
        }
      });
    } catch (err) {
      Swal.fire({
        icon: 'error',
        text: 'Something went wrong when trying to set language'
      });
    }
  }

  return (
    <Dropdown drop="down" alignRight>
      <Dropdown.Toggle as={DropdownTopbarItemToggler} id="dropdown-toggle-my-cart">
        <div className="btn btn-icon btn-clean btn-dropdown btn-lg ml-3" style={{ width: 'unset' }}>
          <img className="h-25px w-25px rounded" src={currentLanguage.flag} alt={currentLanguage.name} />
          {/* <div className="ml-1" style={{ color: style.color }}>
            {currentLanguage.label}
          </div> */}
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu
        className="p-0 m-0 dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround"
        style={{ minWidth: '100px', whiteSpace: 'nowrap' }}
      >
        <ul className="navi navi-hover py-4">
          {languages.map(language => (
            <li
              key={language.lang}
              className={clsx('navi-item', {
                active: language.lang === currentLanguage.lang
              })}
            >
              <a
                href="#"
                onClick={e => {
                  e.preventDefault();
                  changeLanguage(language.lang);
                }}
                className="navi-link"
              >
                <span className="symbol symbol-20 mr-3">
                  <img src={language.flag} alt={language.name} />
                </span>
                <span className="navi-text">{language.name}</span>
              </a>
            </li>
          ))}
        </ul>
      </Dropdown.Menu>
    </Dropdown>
  );
}
